import cx from 'clsx';
import Link from 'next/link';

import styles from './Button.module.scss';

interface ButtonType extends React.ButtonHTMLAttributes<HTMLButtonElement | HTMLAnchorElement> {
    children: string | React.ReactElement | (string | React.ReactElement)[];
    kind?: 'primary' | 'secondary' | 'tertiary' | 'inline';
    href?: string;
    type?: 'button' | 'submit' | 'reset';
    onClick?: () => any;
    className?: string;
    download?: boolean;
    value?: string;
}

export const Button = ({
    children,
    href,
    onClick,
    className,
    download,
    type = 'button',
    kind = 'primary',
    value,
    ...props
}: ButtonType) => {
    return href ? (
        <Link
            download={download}
            className={cx(styles.button, styles[kind], className)}
            href={href}
            {...props}
        >
            {children}
        </Link>
    ) : onClick || value || ['submit', 'reset'].includes(type) ? (
        <button
            className={cx(styles.button, styles[kind], className)}
            {...(onClick && { onClick })}
            {...(value ? { value } : { type })}
            {...props}
        >
            {children}
        </button>
    ) : (
        <span className={cx(styles.button, styles[kind], className)} {...props}>
            {children}
        </span>
    );
};
